import selectPlugin from './select';
import cascaderPlugin from './cascader';
import radioGroupPlugin from './radioGroup';
import checkboxGroupPlugin from './checkboxGroup';
import timePickerPlugin from './timePicker';
import datePickerPlugin from './datePicker';
import rangePickerPlugin from './rangePicker';
import switchPlugin from './switch';
import sliderPlugin from './slider';
import ratePlugin from './rate';
import uploadPlugin from './upload';
import popEditPlugin from './popEdit';
import imageUploadPlugin from './imageUpload';
import transferPlugin from './transfer';

export {
  selectPlugin,
  cascaderPlugin,
  radioGroupPlugin,
  checkboxGroupPlugin,
  timePickerPlugin,
  datePickerPlugin,
  rangePickerPlugin,
  switchPlugin,
  sliderPlugin,
  ratePlugin,
  uploadPlugin,
  popEditPlugin,
  imageUploadPlugin,
  transferPlugin
}

export default [
  selectPlugin,
  cascaderPlugin,
  radioGroupPlugin,
  checkboxGroupPlugin,
  timePickerPlugin,
  datePickerPlugin,
  rangePickerPlugin,
  switchPlugin,
  sliderPlugin,
  ratePlugin,
  uploadPlugin,
  popEditPlugin,
  imageUploadPlugin,
  transferPlugin
];